const state = () => ({
    unconfirmedAlarmCount : 0,
});

const getters = {
    getUnconfirmedAlarmCount: state => state.unconfirmedAlarmCount,
};

const actions = {
    setUnconfirmedAlarmCount({ commit }, data) {
        commit('SET_UNCOMFIRMED_ALARM_COUNT' , data);
    },
};

const mutations = {
	SET_UNCOMFIRMED_ALARM_COUNT(state, payload) {
		state.unconfirmedAlarmCount = payload;
	},    
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
